/**
 * schemas sagas
 */
import { call, put, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import get from 'lodash.get';

// Constants
import { ENABLE_SCHEMA, DISABLE_SCHEMA } from './constants';

// Actions
import { enqueueSnackbar } from '../notifications/actions';
import {
    setSchema,
    schemaEnabled,
    setSchemaEnabled,
    schemaEnablingError,
    schemaDisabled,
    setSchemaDisabled,
    schemaDisablingError
} from './actions';

// Selectors
import { idTokenSelector } from '../auth/selectors';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* patchEnableSchema({ payload }) {
    const { schemaId } = payload;
    const idToken = yield select(idTokenSelector);

    const config = {
        method: 'patch',
        url: `${REACT_APP_API_URL}/v1/Schemas/${schemaId}/ref`,
        headers: {
            Authorization: idToken
        },
        data: {
            isEnabled: true
        }
    };

    // Begin
    yield put(setSchemaEnabled(schemaId));

    try {
        const response = yield call(axios, config);
        // Commit
        yield put(schemaEnabled(response.data));
        yield put(setSchema(schemaId, response.data));
    } catch (err) {
        const error = get(err, 'response.data', err);
        const message = get(
            error,
            'response.data.message',
            'There was an error. Please try again later.'
        );

        // Enqueue Snackbar
        yield put(enqueueSnackbar({ message, options: { variant: 'error' } }));

        yield put(schemaEnablingError(error));

        // Revert
        yield put(setSchemaDisabled(schemaId));
    }
}

export function* watchEnableSchema() {
    yield takeLatest(ENABLE_SCHEMA, patchEnableSchema);
}

export function* patchDisableSchema({ payload }) {
    const { schemaId } = payload;
    const idToken = yield select(idTokenSelector);

    const config = {
        method: 'patch',
        url: `${REACT_APP_API_URL}/v1/Schemas/${schemaId}/ref`,
        headers: {
            Authorization: idToken
        },
        data: {
            isEnabled: false
        }
    };

    // Begin
    yield put(setSchemaDisabled(schemaId));

    try {
        const response = yield call(axios, config);
        // Commit
        yield put(schemaDisabled(response.data));
        yield put(setSchema(schemaId, response.data));
    } catch (err) {
        const error = get(err, 'response.data', err);
        const message = get(
            error,
            'response.data.message',
            'There was an error. Please try again later.'
        );

        // Enqueue Snackbar
        yield put(enqueueSnackbar({ message, options: { variant: 'error' } }));

        yield put(schemaDisablingError(error));
        // Revert
        yield put(setSchemaEnabled(schemaId));
    }
}

export function* watchDisableSchema() {
    yield takeLatest(DISABLE_SCHEMA, patchDisableSchema);
}
